export const ID = '0133fa78-0c2c-4b88-b2a5-54666951d058';

export const NAME = 'Facility Public Transportation';
